import { apiAuth, apiResponseType } from ".";

export const getAbsenceTypesData = (
  page: number = 1,
  unity_id?: string,
  name?: string,
  filters?: { unit?: string; requires_document?: string }
): apiResponseType =>
  apiAuth.get(
    `absence-types?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }${filters?.unit ? `&unit=${filters.unit}` : ""}${
      filters?.requires_document !== undefined && filters.requires_document !== ""
        ? `&requires_document=${filters.requires_document}`
        : ""
    }`
  );

export const registerAbsenceTypeData = (data) =>
  apiAuth.post("/absence-types/store", data) as apiResponseType;

export const deleteAbsenceTypeData = (uuid: string) =>
  apiAuth.delete(`absence-types/${uuid}/destroy`) as apiResponseType;

export const updateAbsenceTypeData = (uuid: string, data) =>
  apiAuth.post(`absence-types/${uuid}/update`, data) as apiResponseType;

export const getShowAbsenceType = (uuid: string) =>
  apiAuth.get(`absence-types/${uuid}/show`) as apiResponseType;

export const searchAbsenceTypeData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `absence-types?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusAbsenceType = (uuid: string) =>
  apiAuth.put(`absence-types/${uuid}/toggle-status`) as apiResponseType;

export const getSelectAbsenceTypes = (params?: { is_vacation?: boolean }) =>
  apiAuth.get(`absence-types/select`, { params }) as apiResponseType;
